<template>
  <ion-item v-if="!online" color="danger">
    <ion-icon slot="start" :icon="cloudOfflineOutline"></ion-icon>
    <ion-label>Offline</ion-label>
  </ion-item>
</template>

<script lang="ts" setup>
import {
    IonItem,
    IonIcon,
    IonLabel,
} from '@ionic/vue';
import {cloudOfflineOutline} from 'ionicons/icons';
import {online} from "@/http/connection-status";
</script>
